// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pu-filter-selected-item-box[data-v-bd26ad50] {\n  color: var(--sea);\n  background-color: #edf5f4;\n  border-radius: 6px;\n  padding: 0.38rem 0.6rem;\n  font-weight: 400;\n  font-size: 0.9rem;\n}", ""]);
// Exports
module.exports = exports;
